import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { securityHubContentExtension, securityHubApi } from './extensions';
import { rootRouteRef } from '../routes';
/**
 * @alpha
 */
export const awsSecurityHubPlugin = createFrontendPlugin({
    pluginId: 'aws-securityhub',
    routes: {
        index: rootRouteRef
    },
    extensions: [securityHubContentExtension, securityHubApi],
});